import ReactDOM from 'react-dom/client'; 
import Portfolio from './App';
import React from 'react';
import './index.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container); // Create a root
root.render(<Portfolio />); // Render the app to the root